import { render, staticRenderFns } from "./EventCreateButton.vue?vue&type=template&id=6b7121da"
import script from "./EventCreateButton.vue?vue&type=script&lang=js"
export * from "./EventCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports